import { REPORT_ENDPOINT } from '../../../../../api/endpoint';
export const FORECAST_BY_ROOM_TYPE_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/room_type_forecast`;
export const FORECAST_BY_ROOM_TYPE_COLUMNS_REPORT_ENDPOINT = `settings/reports/reservation_forecast_by_room_type`;
